<template>
  <div class="my_cropper">
    <!-- 可定制大小的裁剪软件 -->
    <!-- 上传组件 -->
    <el-upload
      class="upload-demo"
      action
      drag
      :auto-upload="false"
      :show-file-list="false"
      :on-change="changeUpload"
    >
      <template v-if="!params[config['fileId']] || params[config['fileId']].length<=0">
        <div class="upload_btn" :style="{width:config.width+'px',height:config.height+'px'}">
           <i :style="{lineHeight:config.height+'px'}" class="el-icon-plus avatar-uploader-icon"></i>
        </div>
      </template>
      <img v-else class="finaly_img" :src="params[config['imgPath']]"  :style="{width:config.width+'px',height:config.height+'px'}" />
    </el-upload>
    <!-- 弹窗 -->
    <el-dialog title="图片剪裁（滚轮放大缩小）" :visible.sync="dialogVisible" width="800px">
      <div class="cropper-content">
        <div class="cropper-content-l">
          <div class="cropper" style="text-align:center">
            <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
              @realTime="realTime"
            ></vueCropper>
          </div>
        </div>
        <div class="cropper-content-r">
          <h5>预览</h5>
          <!-- 预览 -->
          <div
            class="show-preview"
            :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden',}"
          >
            <div :style="previews.div">
              <img :src="option.img" :style="previews.img" />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props:{
    params:{
      type:Object
    },
    config:{
      type:Object
    }
  },
  data() {
    return {
      img: this.params.coverPath || "",
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: this.config.autoCropWidth, // 默认生成截图框宽度
        autoCropHeight: this.config.autoCropHeight, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: this.config.fixedNumber, // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      loading: false,
      fileInfo: null,
      previews: "" //预览
      //   previewStyle1: null
    };
  },
  methods: {
    // 上传按钮   
    async changeUpload(file, fileList) {
      let size = this.config.imgSize || 0.5;//默认500KB
      const isLt5M = file.size / 1024 / 1024 < size;//限制图片容量大小
      let sizeText = this.config.imgSize < 1?(this.config.imgSize*1024)+'KB':(this.config.imgSize)+'M';//小于1M显示KB
      if (!isLt5M) {
        this.$message.error(sizeText);
        return false;
      }
      //   base64转换
      let src = await this.common.readFile(file.raw);
      this.fileInfo = file.raw;
      // console.log(file.raw);
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.option = Object.assign({}, this.option, {
        img: src
      });
      this.dialogVisible = true;
    },
    // 点击裁剪
    finish() {
      let self = this;
      // 获取截图的base64 数据
      this.$refs.cropper.getCropData(data => {
        // console.log(data)
        // 预览图
        self.params[self.config['imgPath']] = data;
      });
      // 获取截图的blob数据

      this.$refs.cropper.getCropBlob(data => {
        // 上传服务器
        self.uploadFile(data);
      });
    },
    // 上传文件到服务器
    uploadFile(data) {
      var file = new File([data], this.fileInfo.name, {
        type: this.fileInfo.type
      });
      this.api
        .uploadFile({
          file: file,
          catalog: "CatalogUserHead",
          is_public_read: true
        })
        .then(res => {
          if (res.error.err_code !== 0) return;
          //fileId,filePath
          this.$emit("uploadObj", res.obj);
          this.params[this.config.fileId] = res.obj.fileId;
          this.dialogVisible = false;
        });
    },
    // 预览
    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      //   this.previewStyle1 = {
      //     width: previews.w + "px",
      //     height: previews.h + "px",
      //     overflow: "hidden",
      //     margin: "0",
      //     zoom: h
      //   };

      this.previews = data;
    }
  }
};
</script>

<style lang="scss">
.my_cropper {
    .upload-demo .upload_btn {
      background: rgba(245, 245, 245, 1);
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      h3 {
        font-size: 14px;
        color: #666;
        font-weight: normal;
        line-height: 34px;
      }
      p {
        font-size: 12px;
        color: #999;
        line-height: 21px;
      }
    }
  .finaly_img {
    object-fit: contain;
    display: block;
  }
  .el-upload-dragger {
    width: auto;
    height: auto;
  }
}
.cropper-content {
  display: flex;
  justify-content: space-between;
  .cropper {
    width: 400px;
    height: 300px;
  }
  .cropper-content-r {
    & > h5 {
      font-size: 16px;
      text-align: center;
      font-weight: 600;
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>